<!--
  ~ Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<!-- The theme and direction classes are repeated because the panel sits outside the grid element that carries them.
     ag-ltr is what ag-grid.css scopes the label gap, picker padding and dropdown indent to. -->
@let p = paging();
<div class="ag-theme-balham ag-ltr server-paging-panel">
  <div class="ag-paging-panel ag-unselectable">
    <div class="server-paging-panel-start"><ng-content></ng-content></div>
    <span class="ag-paging-page-size">
      <div class="ag-picker-field ag-labeled ag-label-align-left ag-select" role="presentation">
        <div class="ag-label">Page Size:</div>
        <div class="ag-wrapper ag-picker-field-wrapper"
             [class.ag-picker-collapsed]="!pageSizePickerOpen()"
             [class.ag-picker-expanded]="pageSizePickerOpen()"
             tabindex="0" role="combobox" aria-label="Page Size" [attr.aria-controls]="pageSizeListId"
             [attr.aria-expanded]="pageSizePickerOpen()"
             [attr.aria-activedescendant]="pageSizePickerOpen() ? pageSizeListId + '-' + pageSizePickerHighlight() : null"
             (click)="togglePageSizePicker()" (keydown)="onPageSizePickerKeyDown($event)"
             (focusout)="onPageSizePickerFocusOut($event)">
          <div class="ag-picker-field-display">{{ p.pageSize() }}</div>
          <div class="ag-picker-field-icon" aria-hidden="true">
            <span class="ag-icon ag-icon-small-down" role="presentation"></span>
          </div>
        </div>
        @if (pageSizePickerOpen()) {
          <div class="ag-select-list ag-list" role="listbox" aria-label="Page Size" [id]="pageSizeListId">
            @for (size of p.pageSizeOptions; track size; let i = $index) {
              <div class="ag-list-item ag-select-list-item" role="option" [id]="pageSizeListId + '-' + i"
                   [class.ag-active-item]="i === pageSizePickerHighlight()"
                   [attr.aria-selected]="size === p.pageSize()"
                   (mousedown)="$event.preventDefault(); changePageSize(size)">
                <span>{{ size }}</span>
              </div>
            }
          </div>
        }
      </div>
    </span>
    <!-- &ngsp; keeps the spaces Angular would otherwise drop, which would read as "1to20of953". -->
    <span class="ag-paging-row-summary-panel" role="status">
      <span class="ag-paging-row-summary-panel-number">{{ p.firstRowOnPage() }}</span>
      <span>&ngsp;to&ngsp;</span>
      <span class="ag-paging-row-summary-panel-number">{{ p.lastRowOnPage() }}</span>
      <span>&ngsp;of&ngsp;</span>
      <span class="ag-paging-row-summary-panel-number">{{ p.totalRows() }}</span>
    </span>
    <span class="ag-paging-page-summary-panel" role="presentation">
      <div class="ag-button ag-paging-button" role="button" aria-label="First Page" tabindex="0"
           [class.ag-disabled]="p.onFirstPage()" [attr.aria-disabled]="p.onFirstPage()"
           (click)="p.goToFirstPage()" (keydown.enter)="p.goToFirstPage()"
           (keydown.space)="$event.preventDefault(); p.goToFirstPage()">
        <span class="ag-icon ag-icon-first" role="presentation"></span>
      </div>
      <div class="ag-button ag-paging-button" role="button" aria-label="Previous Page" tabindex="0"
           [class.ag-disabled]="p.onFirstPage()" [attr.aria-disabled]="p.onFirstPage()"
           (click)="p.goToPreviousPage()" (keydown.enter)="p.goToPreviousPage()"
           (keydown.space)="$event.preventDefault(); p.goToPreviousPage()">
        <span class="ag-icon ag-icon-previous" role="presentation"></span>
      </div>
      <span class="ag-paging-description" role="status">
        <span>Page&ngsp;</span>
        <span class="ag-paging-number">{{ p.currentPage() }}</span>
        <span>&ngsp;of&ngsp;</span>
        <span class="ag-paging-number">{{ p.totalPages() }}</span>
      </span>
      <div class="ag-button ag-paging-button" role="button" aria-label="Next Page" tabindex="0"
           [class.ag-disabled]="p.onLastPage()" [attr.aria-disabled]="p.onLastPage()"
           (click)="p.goToNextPage()" (keydown.enter)="p.goToNextPage()"
           (keydown.space)="$event.preventDefault(); p.goToNextPage()">
        <span class="ag-icon ag-icon-next" role="presentation"></span>
      </div>
      <div class="ag-button ag-paging-button" role="button" aria-label="Last Page" tabindex="0"
           [class.ag-disabled]="p.onLastPage()" [attr.aria-disabled]="p.onLastPage()"
           (click)="p.goToLastPage()" (keydown.enter)="p.goToLastPage()"
           (keydown.space)="$event.preventDefault(); p.goToLastPage()">
        <span class="ag-icon ag-icon-last" role="presentation"></span>
      </div>
    </span>
  </div>
</div>
